const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');

const OrderCountView = require('app/supplier/stat/OrderCountView');
const NetSaleView = require('app/supplier/stat/NetSaleView');
const NetSaleProductRankView = require('app/supplier/stat/NetSaleProductRankView');
const VolumeProductRankView = require('app/supplier/stat/VolumeProductRankView');
const NetSaleRangeRankView = require('app/supplier/stat/NetSaleRangeRankView');

class StatTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'supplier': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmitForm = this.onSubmitForm.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.supplier = this.settings.supplier;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }

    onDOMReady(){
        this.supplierForm.onDOMReady();
    }

    buildTab(){


        this.$resultContainer = $('<div/>');

        this.$content = $('<div/>')
        .append(this.buildForm())
        .append(this.$resultContainer);


        this.$container
        .html('')
        .append(this.$content);

        this.$form.trigger('submit');
    }


    buildForm(){
        let begin = moment().startOf('year').format('YYYY-MM-DD');
        let end = moment().endOf('year').format('YYYY-MM-DD');

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-info')
        .append(
            $('<i/>')
            .addClass('far fa-search')
        );

        this.$form = $('<form/>')
        .addClass('product-stat-form')
        .addClass('white-box')
        .on("submit",this.onSubmitForm);

        let $row = $('<div/>')
        .addClass('row');

        this.$inputFrom = $('<input/>')
        .attr('id','from')
        .attr('type','date')
        .attr('name','from')
        .addClass('form-control')
        .attr('required','required')
        .val(begin);

        $row.append(
            $('<div/>')
            .addClass('col-5 p-2')
            .append(
                $('<div/>')
                .append(
                    $('<div/>')
                    .addClass('input-group')
                    .append(
                        $('<div/>')
                        .addClass('input-group-text')
                        .append(window.translate('from'))
                    )
                    .append(this.$inputFrom)
                )
            )
        );

        this.$inputTo = $('<input/>')
        .attr('id','to')
        .attr('type','date')
        .attr('name','to')
        .addClass('form-control')
        .attr('required','required')
        .val(end);

        $row.append(
            $('<div/>')
            .addClass('col-5 p-2')
            .append(
                $('<div/>')
                .append(
                    $('<div/>')
                    .addClass('input-group')
                    .append(
                        $('<div/>')
                        .addClass('input-group-text')
                        .append(window.translate('to'))
                    )
                    .append(this.$inputTo)
                )
            )
        );

        $row.append(
            $('<div/>')
            .addClass('col-2 p-2 mt-auto')
            .append(this.$btnSubmit)
        );

        this.$form
        .addClass('d-flex justify-content-center')
        .append($row);

        return this.$form;
    }

    onSubmitForm(event){
        event.preventDefault();
        event.stopPropagation();
        
        this.loadData();
    }

    loadData(){
        var self = this;

        this.$resultContainer
        .html('')
        .append(window.App.generateLoader())

        let queries = [
            this.buildSupplierStatisticQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildResult(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildSupplierStatisticQuery(){
        var self = this;

        let parameters = {
            'supplier': this.supplier.id,
            'from': this.$inputFrom.val(),
            'to': this.$inputTo.val(),
        };

        let fields = [
            'supplier { id name }',
            'netSaleByMonth { x y }',
            'ordersCountByMonth { x y }',
            'netSaleProductRank { product { number reference } netSale }',
            'volumeProductRank { product { number reference unit } volume }',
            'netSaleRangeRank { range { name } netSale }',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierStatistic',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    buildResult(data){

        this.supplierStatistic = data.supplierStatistic;


        this.supplier =  this.supplierStatistic.supplier;
        this.netSaleByMonth = this.supplierStatistic.netSaleByMonth;
        this.ordersCountByMonth = this.supplierStatistic.ordersCountByMonth;
        this.netSaleProductRank = this.supplierStatistic.netSaleProductRank;
        this.volumeProductRank = this.supplierStatistic.volumeProductRank;
        this.netSaleRangeRank = this.supplierStatistic.netSaleRangeRank;

        this.$netSaleByMonthContainer = $('<div/>')
        .addClass('white-box');
        this.$ordersCountByMonthContainer = $('<div/>')
        .addClass('white-box');
        this.$netSaleProductRankContainer = $('<div/>')
        .addClass('white-box');
        this.$volumeProductRankContainer = $('<div/>')
        .addClass('white-box');
        this.$netSaleRangeRankContainer = $('<div/>')
        .addClass('white-box');


        this.$resultContainer
        .html('')
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$netSaleByMonthContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$ordersCountByMonthContainer)
            )
        )
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$netSaleProductRankContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$volumeProductRankContainer)
            )
        )
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-2')
                .append(this.$netSaleRangeRankContainer)
            )
        );


        
        this.orderCountView = new OrderCountView({
            '$container': this.$ordersCountByMonthContainer,
            'data': this.ordersCountByMonth,
            'supplier': this.supplier,
        });

        this.netSaleView = new NetSaleView({
            '$container': this.$netSaleByMonthContainer,
            'data': this.netSaleByMonth,
            'supplier': this.supplier,
        });

        this.netSaleProductRankView = new NetSaleProductRankView({
            '$container': this.$netSaleProductRankContainer,
            'data': this.netSaleProductRank,
            'supplier': this.supplier,

        });

        this.volumeProductRankView = new VolumeProductRankView({
            '$container': this.$volumeProductRankContainer,
            'data': this.volumeProductRank,
            'supplier': this.supplier,
        });
        

        this.netSaleRangeRankView = new NetSaleRangeRankView({
            '$container': this.$netSaleRangeRankContainer,
            'data': this.netSaleRangeRank,
            'supplier': this.supplier,

        });
    }

}

module.exports = StatTab;

